angular.module("ainapp")
    .controller("viewResignationFormController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window", "LanguageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window, LanguageService) {

            $scope.PageName = "View Resignation Form";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }



            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        MainService.ResignationFormsInGrid(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.LanguageData.NetworkError);
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            "Employee.Name": {
                                type: "string",
                                editable: false,
                            },

                            Date: {
                                type: "date",
                                editable: false,
                            },
                            ResignationDate: {
                                type: "date",
                                editable: false,
                            },
                            Reason: {
                                type: "string",
                                editable: false,
                            },

                            Remarks: {
                                type: "string",
                                editable: false,
                            },
                            Status: {
                                type: "string",
                                editable: false,
                            },


                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },


                columns: [
                    {
                        field: "Employee.Name",
                        title: "Employee",
                        headerTemplate: "{{LanguageData.Employee}}",
                        },

                    {
                        field: "Date",
                        title: "Date",
                        headerTemplate: "{{LanguageData.Date}}",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        },
                    {
                        field: "ResignationDate",
                        title: "ResignationDate",
                        headerTemplate: "{{LanguageData.ResignationDate}}",
                        template: "#= kendo.toString(kendo.parseDate(ResignationDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        },
                    {
                        field: "Reason",
                        title: "Reason",
                        headerTemplate: "{{LanguageData.Reason}}",
                        },
                    {
                        field: "Status",
                        title: "Status",
                        headerTemplate: "Status",
                        },


                    {
                        field: "Remarks",
                        title: "Remarks",
                        headerTemplate: "{{LanguageData.Remarks}}",

                        },
                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}",
                        template: "<button class=' btn-default btn-sm fa fa-save' ng-click='update(dataItem)'> </button>",
                        width: '80px'
                        },
            ],
            };




            $scope.SelectedData = {};
            $scope.update = function (data) {
                $scope.SelectedData = angular.copy(data);
                $("#updateModal").modal("show");
            }

            $scope.SaveData = function () {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.UpdateResignationForm($scope.SelectedData).then(function (response) {
                    if (response.data) {
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        toastr.success($scope.LanguageData.Success);
                        $("#updateModal").modal("hide");
                    } else {
                        toastr.error($scope.LanguageData.Error);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error($scope.LanguageData.NetworkError);
                    $.LoadingOverlay("hide");
                });
            }

    }]);
